import React from 'react';
import { SalesOrderInfo } from '../../../../store/slices/salesOrders';
import { TableRow } from './TableRow';
import { ReportTableColumn, RowAction } from './interfaces';
import { ICustomer } from '../../../../store/slices/customers';
import { ISalesOrderProduct } from '../../../../store/slices/salesOrderProducts';
import { IDigitalHealthProfile } from '../../SelectedSalesOrder/DigitalHealthProfileTab';
import { IOtherService } from '../../../../screens/VideoConsultingRoom/VideoMenu/AdditionalServicesTab';

const TableBody: React.FC<{
  rows:
    | SalesOrderInfo[]
    | ICustomer[]
    | ISalesOrderProduct[]
    | IDigitalHealthProfile[]
    | IOtherService[];
  actions: RowAction[];
  columns: ReportTableColumn[];
  isInCheckIn?: boolean;
  isInReport?: boolean;
}> = ({ rows, actions, columns, isInCheckIn, isInReport }) => {
  return (
    <tbody>
      {rows.map((row, index) => (
        <TableRow
          key={index}
          row={row}
          actions={actions}
          columns={columns}
          lastRow={index === rows.length - 1}
          isInCheckIn={isInCheckIn}
          isInReport={isInReport}
        />
      ))}
    </tbody>
  );
};

export { TableBody };
